import { defineMutation, useMutation, useQueryCache } from '@pinia/colada';

import { getPropertyStatisticsQueryKey, portfolioQueryKey } from '@tallo/investor/property';
import { renterConversationQueryKey, renterInquiriesQueryKey } from '@tallo/investor/renter';

import { RescheduleShowingRequestDto } from '../interfaces/reschedule-showing-request.interface';
import { showingsQueryKey } from '../queries/showings.query';
import showingRequestsService from '../services/showing-requests.service';

export const useRescheduleShowingRequest = defineMutation(() => {
  return useMutation({
    mutation(payload: { propertyId: string; rescheduleShowingRequestDto: RescheduleShowingRequestDto }) {
      return showingRequestsService.reschedule(payload.propertyId, payload.rescheduleShowingRequestDto);
    },
    async onSuccess(_, payload) {
      const queryCache = useQueryCache();

      queryCache.invalidateQueries({ key: getPropertyStatisticsQueryKey(payload.propertyId) });
      queryCache.invalidateQueries({ key: [portfolioQueryKey] });
      queryCache.invalidateQueries({ key: [renterInquiriesQueryKey] });
      queryCache.invalidateQueries({ key: [renterConversationQueryKey] });
      await queryCache.invalidateQueries({ key: [showingsQueryKey] });
    },
  });
});
